import React from 'react';

interface StatProps {
  value: string | number;
  label: string;
  unit?: string;
}

export default function Stat({ value, label, unit }: StatProps) {
  return (
    <div className="px-s5 py-[18px] bg-surface border border-border rounded-xs border-l-[2px] border-l-accent">
      <div className="font-mono text-[30px] font-medium text-text leading-none tracking-[-1px]">
        {value}
        {unit && <span className="text-[14px] text-text-muted ml-1">{unit}</span>}
      </div>
      <div className="mt-2.5 font-mono text-[10px] text-text-muted uppercase tracking-[0.8px]">
        {label}
      </div>
    </div>
  );
}
